import JSONAPIClient from '../JSONAPIClient'

JSONAPIClient.define('legal_agreement', {
  id: '',
  agreement_type: '',
  text: '',
})
